/*******************************************************************************
**
** GE Aerospace Unified Theme Scripts
**
*******************************************************************************/

//import { Toast, Tooltip } from './_bootstrap';

(function ($) {

  var selected = [];
  $(window).on('load', function() {
    $('#views-exposed-form-articles-popular-topics-block div.btn').eq(0).addClass('active');
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('categoryids')) {
      let categoryids_str = urlParams.get('categoryids');
      let categoryids = categoryids_str.split(',');
      const sE = document.getElementById('edit-field-content-categories-target-id');
      if (sE) {
        for (var i = 0; i < sE.options.length; i++) {
          var option = sE.options[i];
          if (categoryids.includes(option.value)) {
            option.setAttribute('selected', 'selected');
            if(!selected.includes(option.value)) {
              selected.push(option.value);
              $("input[type=checkbox][id="+option.value+"]").prop('checked',true).addClass('active');
            }
          }
        }
      }
    }
  });

  Drupal.AjaxCommands.prototype.scrollTop = function (ajax, response) {
    var offset = $('#ge-articles-filter').offset();
    if(offset) {
      var scrollTarget = response.selector;
      while ($(scrollTarget).scrollTop() == 0 && $(scrollTarget).parent()) {
        scrollTarget = $(scrollTarget).parent();
      }
      $(scrollTarget).animate({ scrollTop: offset.top}, 500);
    }
  };

  Drupal.behaviors.mybehavior = {
    attach: function (context, settings) {
      // * Tooltip initialization, remove it if not necessary
      document
        .querySelectorAll('[data-toggle="tooltip"]')
        .forEach((tooltipElement) => new Tooltip(tooltipElement));

      // * Toast initialization, remove it if not necessary
      document
        .querySelectorAll('.toast')
        .forEach((toastElement) => new Toast(toastElement));

      let refineBtn= document.querySelector(".refine-search-btn");
      let refineMobiileSection = document.querySelector(".refine-section");
      let wholeListSection = document.querySelector(".list-section");
      let topbannersection = document.querySelector(".top-img-container");

      const showHideRefineSection = (showRefineSection, listSection) => {
        showRefineSection ? refineMobiileSection.classList.add("refine-list-mobile") : refineMobiileSection.classList.remove("refine-list-mobile")

        if (wholeListSection) {
          wholeListSection.style.display = listSection;
        }
        topbannersection.style.display = listSection;
      };

      if(refineBtn){
        refineBtn.addEventListener('click',  ()=> {
          window.scrollTo(0, 0);
          showHideRefineSection(true, "none")
        })
        document.querySelector(".btn-close-icon").addEventListener('click', () => {
          showHideRefineSection(false, "block");
        })
        document.querySelector(".apply").addEventListener('click', (e) => {
          showHideRefineSection(false, "block");
          e.preventDefault();
        })

        window.addEventListener('resize', () => {
          if (document.body.clientWidth > 768) {
            showHideRefineSection(false, "block");
          }
        });
      }

      $(document).ready(function () {
        if ($.fn.slick) {
          $(".slider-for").not('.slick-initialized').slick({
            slidesToShow: 2.4,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            autoplay: false,
            variableWidth: true,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3.2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                },
              },
            ],
          });
          $(".prev-btn").click(function () {
            $(".slider-for").slick("slickPrev");
          });
          $(".next-btn").click(function () {
            $(".slider-for").slick("slickNext");
          });
          $(".prev-btn").addClass("ctrl-disabled");
          $(".slider-for").on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
              $(".prev-btn").addClass("ctrl-disabled");
            }
            else {
              $(".prev-btn").removeClass("ctrl-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
              $(".next-btn").addClass("ctrl-disabled");
            }
            else {
              $(".next-btn").removeClass("ctrl-disabled");
            }
          });
        }

        // Article Landing Page
        $('#views-exposed-form-articles-popular-topics-block div.btn').on('click', function(e) {
          e.preventDefault();
          selected = [];
          var selectFilter = $('#views-exposed-form-articles-popular-topics-block select[name="field_content_categories_target_id"]');
          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          $('#views-exposed-form-articles-popular-topics-block select[name="field_content_categories_target_id"]').trigger('change');
          $('#views-exposed-form-articles-popular-topics-block').find('[data-drupal-selector*=edit-submit-articles]').trigger('click');
        });

        // Press Release Filter Page
        //$('#views-exposed-form-press-releases-page-1 input[type=checkbox]').unbind('click').on('click', function(e) {
        $('[id^=views-exposed-form-press-releases] input[type=checkbox]').unbind('click').on('click', function(e) {
          e.preventDefault();
          //var selectFilter = $('#views-exposed-form-press-releases-page-1 select[name="field_content_categories_target_id[]"]');
          var selectFilter = $('[id^=views-exposed-form-press-releases] select[name="field_content_categories_target_id[]"]');

          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          //$('#views-exposed-form-press-releases-page-1 select[name="field_content_categories_target_id[]"]').trigger('change');
          //$('#views-exposed-form-press-releases-page-1').find('[data-drupal-selector*=edit-submit]').trigger('click');
          
          $('[id^=views-exposed-form-press-releases] select[name="field_content_categories_target_id[]"]').trigger('change');
          $('[id^=views-exposed-form-press-releases]').find('[data-drupal-selector*=edit-submit]').trigger('click');
        });

        // Article Filter Page
        //$('#views-exposed-form-articles-filter-list-page-1 input[type=checkbox]').unbind('click').on('click', function(e) {
        $('[id^=views-exposed-form-articles-filter-list] input[type=checkbox]').unbind('click').on('click', function(e) {
          e.preventDefault();
          //var selectFilter = $('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]');
          var selectFilter = $('[id^=views-exposed-form-articles-filter-list] select[name="field_content_categories_target_id[]"]');

          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          //$('#views-exposed-form-articles-filter-list-page-1 select[name="field_content_categories_target_id[]"]').trigger('change');
          //$('#views-exposed-form-articles-filter-list-page-1').find('[data-drupal-selector*=edit-submit]').trigger('click');

          $('[id^=views-exposed-form-articles-filter-list] select[name="field_content_categories_target_id[]"]').trigger('change');
          $('[id^=views-exposed-form-articles-filter-list]').find('[data-drupal-selector*=edit-submit]').trigger('click');
        });

        //$('#views-exposed-form--ir-updates-archive--page-1 input[type=checkbox]').unbind('click').on('click', function(e) {
        $('[id^=views-exposed-form--ir-updates-archive] input[type=checkbox]').unbind('click').on('click', function(e) {
          e.preventDefault();
          //var selectFilter = $('#views-exposed-form--ir-updates-archive--page-1 select[name="field_content_categories_target_id[]"]');
          var selectFilter = $('[id^=views-exposed-form--ir-updates-archive] select[name="field_content_categories_target_id[]"]');

          var id = $(e.currentTarget).attr('id');
          if($(e.currentTarget).hasClass('active') == true) {
            const index = selected.indexOf(id);
            if (index > -1) {
              selected.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
          else {
            selected.push(id);
          }

          // Set the new value in the SELECT element
          selectFilter.val(selected);

          // Do it! Trigger the select box
          //filter.trigger('change');
          //$('#views-exposed-form--ir-updates-archive--page-1 select[name="field_content_categories_target_id[]"]').trigger('change');
          //$('#views-exposed-form--ir-updates-archive--page-1').find('[data-drupal-selector*=edit-submit]').trigger('click');
          
          $('[id^=views-exposed-form--ir-updates-archive] select[name="field_content_categories_target_id[]"]').trigger('change');
          $('[id^=views-exposed-form--ir-updates-archive]').find('[data-drupal-selector*=edit-submit]').trigger('click');
        });

        $.each(selected, function(i,value){
          $('#views-exposed-form-articles-popular-topics-block div.btn').removeClass('active');
          $("input[type=checkbox][id="+value+"]").prop('checked',true).addClass('active');
          $("#"+value).addClass('active');
        });

        $('.views-exposed-form [data-drupal-selector=edit-reset]').removeClass('btn-primary');

        // Article detail page
        if($('.comment-comment-form')) {
          $('input[id^=edit-cancel]').removeClass('btn');
          jQuery('label[for^="edit-name"]').text('Name *');
          jQuery('label[for^="edit-comment-body-0-value"]').text('Comment *');
        }
        if($('.comment-comment-form .js-form-submit')) {
          $('input[id^=edit-ajax-comments-reply-form]').removeClass('button--primary js-form-submit form-submit btn btn-primary');
        }
        if($('[data-drupal-selector=comment-form]')[0]) {
          if($('.alert').hasClass('alert-success')) {
            $('[data-drupal-selector=comment-form]')[0].reset();
          }
        }
        if($('.js-comment.by-viewer')) {
          $('.js-comment.by-viewer').each(function() {
            if($(this).next().hasClass('indented')) {
              $(this).next().appendTo(this);
            }
          });
        }
      });
    }
  };

})(jQuery);

